export default class CreateWorkerSkillRequest {
    skillId: string;
    status: number;
    source: number;
}